import {
    FilterAccordionItem,
    FilterCheckbox,
    FilterChipItemButton,
} from 'components/FilterAccordion';
import HealthStatTooltip from 'components/HealthStatTooltip';
import { PricePointMetricIcon } from 'components/HealthStats';
import Stack from './Stack';
import { getScoreColor } from 'utils/helpers';
import styled from 'styled-components';

const HealthStatBar = styled.span`
    display: inline-block;
    background-color: ${({ score, $metricLabel }) =>
        getScoreColor(score, false, $metricLabel)};
    width: ${({ score }) => (typeof score !== 'number' ? 0 : score * 10)}%;
    min-width: 1%;
    height: ${({ theme }) => theme.space_3}px;
    border-radius: ${({ theme }) => theme.space_16}px;
`;

const HealthStatWrapperWithProps = styled(Stack).attrs(
    ({ as = 'span', $space = (theme) => `${theme.space_3}px`, ...props }) => ({
        as,
        $space,
        ...props,
    }),
)`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-right: ${({ theme }) => theme.space_8}px;
`;
const HealthStatWrapper = HealthStatWrapperWithProps;

export function HealthStatFilterOption({
    children,
    score,
    metricLabel,
    label,
    scoreLabel,
    upperScoreThreshold,
    ...props
}) {
    return (
        <HealthStatTooltip metricLabel={metricLabel} label={label}>
            <FilterCheckbox {...props}>
                <HealthStatWrapper as="span">
                    <span>{children}</span>
                    <HealthStatBar score={score} $metricLabel={metricLabel} />
                </HealthStatWrapper>
            </FilterCheckbox>
        </HealthStatTooltip>
    );
}

const SelectHealthStatFilterCheckbox = styled(FilterCheckbox)`
    &:hover {
        color: ${({ $score, $metricLabel }) =>
            getScoreColor($score, true, $metricLabel)};
    }
`;

export function SelectHealthStatFilterOption({
    children,
    score,
    metricLabel,
    label,
    scoreLabel,
    upperScoreThreshold,
    ...props
}) {
    return (
        <HealthStatTooltip metricLabel={metricLabel} label={label}>
            <SelectHealthStatFilterCheckbox
                $score={score}
                $metricLabel={metricLabel}
                {...props}
            >
                {children}
            </SelectHealthStatFilterCheckbox>
        </HealthStatTooltip>
    );
}

export function PopularityShareFilterOption({
    children,
    score,
    metricLabel,
    label,
    scoreLabel,
    upperScoreThreshold,
    ...props
}) {
    return (
        <HealthStatTooltip metricLabel={metricLabel} label={label}>
            <FilterCheckbox {...props}>
                <HealthStatWrapper as="span">
                    <span>{children}</span>
                </HealthStatWrapper>
            </FilterCheckbox>
        </HealthStatTooltip>
    );
}

export function PriceHealthStatFilterOption({
    children,
    score,
    metricLabel,
    label,
    checked,
    onChange,
}) {
    return (
        <HealthStatTooltip
            metricLabel={metricLabel}
            label={label}
            score={score}
        >
            <FilterCheckbox checked={checked} onChange={onChange}>
                <HealthStatWrapper as="span">
                    <Stack
                        $direction="row"
                        as="span"
                        $space="1ch"
                        css="display: inline-flex;"
                    >
                        <span
                            css={`
                                color: ${({ theme }) => theme.gray_3};
                                display: inline-flex;
                            `}
                        >
                            <PricePointMetricIcon score={score} />
                        </span>
                        <span>{children}</span>
                    </Stack>
                </HealthStatWrapper>
            </FilterCheckbox>
        </HealthStatTooltip>
    );
}

function HealthStatFilterChipItemButton(props) {
    return (
        <HealthStatTooltip metricLabel={props.metricLabel} label={props.label}>
            <FilterChipItemButton {...props} />
        </HealthStatTooltip>
    );
}

function HealthStatFilterAccordionItem({
    mixpanelContext = 'HealthStatsFilterSelect',
    FilterOption = HealthStatFilterOption,
    FilterChipItemButton = HealthStatFilterChipItemButton,
    $space = (theme) => `${theme.space_6}px`,
    ...props
}) {
    return (
        <FilterAccordionItem
            mixpanelContext={mixpanelContext}
            FilterOption={FilterOption}
            FilterChipItemButton={FilterChipItemButton}
            $space={$space}
            {...props}
        />
    );
}

export default HealthStatFilterAccordionItem;
